import { GetterTree } from 'vuex';
import { IState } from './type';
import { IRootState } from '../../../store/types';

const getters: GetterTree<IState, IRootState> = {};

export default getters;
